/** @format */
import axios from "axios";
import CheckToken from "../../../src/utils/checkToken/CheckToken";

export const deleteNote = async (noteId) => {
  const token = await CheckToken();
  if (!token) {
    // Redirect to login page
    window.location.href = "/login";
  }

  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/notes/delete-note/${noteId}`, // id parametresini URL'ye ekliyoruz
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Silme işlemi başarılıysa başarılı mesajı döner
    return response.data;
  } catch (error) {
    // Hata durumunda hata mesajını döner
    console.error("Silme işlemi sırasında bir hata oluştu:", error);
    throw new Error("Silme işlemi başarısız oldu.");
  }
};
